import { Box, makeStyles, lighten, Paper, Grid } from '@material-ui/core';
import { CORP_BLUE } from 'config/config';
import React, { Fragment } from 'react';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(4),
    backgroundColor: lighten(theme.palette.background.paper, 0.1),
  },
  body: {
    margin: 10,
    padding: 10,
  },
  container: {
    maxHeight: 415,
  },
  table: {
    border: '1px solid #ddd',
  },
  tableOuline: {
    minWidth: '100%',
    border: '1px solid #ddd',
  },
  tableHeader: {
    backgroundColor: CORP_BLUE,
    color: 'white',
  },
  tableRow: {},
  tableData: {},

  tableTitle: {},
  h1: {
    margin: 5,
    padding: 5,
  },
  h2: {
    margin: 10,
    padding: 5,
  },
  normalParagrah: {
    padding: 5,
  },
  underlinedText: {
    textDecoration: 'underline',
    fontWeight: 'bold',
    padding: 5,
  },
  innerDiv: {
    marginLeft: 25,
    marginRight: 25,
    textAlign: 'justify',
    textJustify: 'inter-word',
  },
  listInLine: {
    display: 'flex',
  },
  innerListDiv: {
    paddingLeft: 20,
  },
  responsiveTableContainer: {
    overflowX: 'auto',
    marginRight: 25,
  },
}));

const AyudaBodyInfo = () => {
  const classes = useStyles();

  return (
    <Fragment>
      <Box className={classes.root}>
        <Paper className={classes.paper}>
          <Grid container className={classes.body}>
            <Grid item xs={12}>
              <h1 className={classes.h1}>Objetivo</h1>
            </Grid>
            <Grid item xs={12} className={classes.innerDiv}>
              <p className={classes.normalParagrah}>
                El objetivo del presente documento es servir de guía a los Prestadores de Salud en la utilización del Sistema
                Seguimiento de Reclamos (Extranet).
              </p>
            </Grid>
            <Grid item xs={12}>
              <h1 className={classes.h1}>Funcionalidades Sistema Seguimiento de Reclamos</h1>
            </Grid>
            <Grid item xs={12}>
              <h2 className={classes.h2}>Menú Sistema Seguimiento de reclamos</h2>
            </Grid>
            <Grid item xs={12} className={classes.innerDiv}>
              <ul>
                <li>
                  Mis asignaciones: En esta vista, los usuarios podrán ver los reclamos que se hayan autoasignado, de acuerdo
                  a definiciones internas de cada prestador de salud, para su gestión.
                </li>
                {/*                 <li>
                  Todos los reclamos: En esta vista se visualizarán todos los reclamos asociados al prestador independiente
                  de la etapa en la cual se encuentren.
                </li> */}
                <li>
                  En espera de respuesta prestador: En esta vista se podrán visualizar todos los reclamos en los cuales la
                  Superintendencia de Salud esté solicitando información al prestador de salud, correspondiendo a las etapas
                  de tramitación del reclamo: Espera respuesta del prestador, Reitera traslado y Reitera solicitud de
                  antecedentes.
                </li>
                <li>
                  Derivaciones: En esta vista se podrán visualizar todos los reclamos cuya vía de tramitación sea “Derivación
                  del reclamo al prestador”, a fin de que éste otorgue respuesta dirigida a la parte reclamante, con copia a
                  esta Superintendencia, dentro del plazo de 15 días hábiles, desde la recepción del reclamo.
                </li>
                <li>Ayuda: En esta vista se podrá visualizar un manual de usuario del sistema de reclamos.</li>
              </ul>
            </Grid>
            <Grid item xs={12}>
              <h2 className={classes.h2}>Documentos Adjuntos</h2>
            </Grid>

            <Grid item xs={12} className={classes.innerDiv}>
              <p className={classes.normalParagrah}>
                El sistema de Seguimiento de reclamos (Extranet) contará con una opción que permitirá subir archivos adjuntos
                al reclamo, en las distintas etapas de tramitación. El tamaño permitido de subida será de 15 MB por archivo y
                el formato permitido será solamente PDF.
              </p>
              <p className={classes.normalParagrah}>
                A continuación, se describen los tipos de documentos que podrán ser subidos al sistema:
              </p>
            </Grid>
            <Grid item xs={12} className={classes.responsiveTableContainer}>
              <table className={classes.tableOuline}>
                <thead className={classes.tableHeader}>
                  <tr>
                    <td className={classes.table}>Tipo de adjunto</td>
                    <td className={classes.table}>Descripción</td>
                    <td className={classes.table}>Etapa</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className={classes.table}>Documentos solicitados de tipo médico, administrativo o financiero.</td>
                    <td className={classes.table}>
                      Se refiere a los documentos solicitados por la Superintendencia al prestador de salud, con el fin de
                      aportar antecedentes necesarios para la resolución del reclamo.
                    </td>
                    <td className={classes.table}>
                      Espera respuesta del prestador, Reitera traslado, Reitera solicitud de antecedentes.
                    </td>
                  </tr>

                  <tr>
                    <td className={classes.table}>Otros Adjuntos.</td>
                    <td className={classes.table}>
                      Se refiere a cualquier antecedente adicional que el prestador desee aportar para la resolución del
                      reclamo.
                    </td>
                    <td className={classes.table}>
                      Cualquier etapa de la tramitación a excepción de las etapas de “Archivo transitorio (Espera de
                      recurso)” y “Archivo definitivo”.
                    </td>
                  </tr>

                  <tr>
                    <td className={classes.table}>Recurso.</td>
                    <td className={classes.table}>
                      Se refiere al recurso de reposición y/o jerárquico, que puede interponer el prestador de salud,
                      respecto de la resolución que resuelva el reclamo.
                    </td>
                    <td className={classes.table}>Solo en etapa “Archivo transitorio (Espera de recurso)”.</td>
                  </tr>

                  <tr>
                    <td className={classes.table}>Informe cumplimiento.</td>
                    <td className={classes.table}>
                      Se refiere al informe que envía el prestador de salud, junto a los antecedentes que acrediten el
                      cumplimiento de lo instruido por resolución de la Superintendencia de Salud, que acoge el reclamo
                      (total o parcialmente).
                    </td>
                    <td className={classes.table}>
                      Sólo si el reclamo se encuentra en las etapas de “Archivo Definitivo” y “Archivo transitorio (Espera de
                      recurso)”.
                    </td>
                  </tr>

                  <tr>
                    <td className={classes.table}>Copia de respuesta al reclamante.</td>
                    <td className={classes.table}>
                      Se refiere al antecedente que acredite la notificación, a la parte reclamante, de la carta de respuesta
                      al reclamo que fue derivado, desde la Superintendencia, al prestador de salud.
                    </td>
                    <td className={classes.table}>
                      Sólo si la vía de tramitación es “Derivación” y etapa es “Archivo Definitivo”.
                    </td>
                  </tr>
                </tbody>
              </table>
            </Grid>
            <Grid item xs={12}>
              <h2 className={classes.h2}>Detalle del reclamo</h2>
            </Grid>
            <Grid item xs={12} className={classes.innerDiv}>
              <p className={classes.normalParagrah}>
                En esta opción los usuarios podrán visualizar los detalles del reclamo separado en las siguientes secciones:
              </p>
              <ol type="a">
                <li>
                  <p className={classes.underlinedText}>Detalle reclamo</p>
                  <p className={classes.normalParagrah}>Se visualizarán los datos asociados al reclamo, tales como:</p>
                  <div className={classes.innerListDiv}>
                    <ul>
                      <li>Nombre y rut del reclamante</li>
                      <li>Nombre y rut del paciente</li>
                      <li>Vía de tramitación actual del reclamo</li>
                      <li>Previsión del paciente</li>
                      <li>Materia del reclamo</li>
                      <li>Etc.</li>
                    </ul>
                  </div>
                </li>
                <li>
                  <p className={classes.underlinedText}>Adjuntos</p>
                  <p className={classes.normalParagrah}>
                    En esta sección se podrán visualizar los documentos asociado al reclamo, ya sea aquéllos con que cuente
                    la Superintendencia de Salud, como aquéllos aportados por el prestador.
                  </p>
                  <div className={classes.innerListDiv}>
                    <ul>
                      <li>Presentación de reclamante (reclamo).</li>
                      <li>Antecedente adicional de reclamante.</li>
                      <li>Oficio de traslado, de reitera traslado.</li>
                      <li>Solicitud de prórroga, oficio que concede dicha prórroga de plazo.</li>
                      <li>Antecedentes médicos, administrativos o financieros.</li>
                      <li>Etc.</li>
                    </ul>
                  </div>
                </li>
              </ol>
            </Grid>
            <Grid item xs={12}>
              <h2 className={classes.h2}>Acciones del sistema</h2>
            </Grid>
            <Grid item xs={12} className={classes.innerDiv}>
              <ol type="a">
                <li>
                  <div className={classes.listInLine}>
                    <p className={classes.underlinedText}>Autoasignar:</p>
                    <p className={classes.normalParagrah}>
                      Permite que un usuario interno –del prestador de salud-, de acuerdo a su perfil, se autoasigne un
                      reclamo para su gestión, no permitiendo que otro usuario realice modificaciones, mientras no sea
                      asignado a otro usuario.
                    </p>
                  </div>
                </li>
                <li>
                  <div className={classes.listInLine}>
                    <p className={classes.underlinedText}>Antecedentes:</p>
                    <p className={classes.normalParagrah}>
                      Acción que permite adjuntar documentos al reclamo –de acuerdo a las indicaciones técnicas informadas- y
                      además, visualizar la historia de documentos subidos, con indicación de fecha y hora.
                    </p>
                  </div>
                </li>
                <li>
                  <div className={classes.listInLine}>
                    <p className={classes.underlinedText}>Prórroga:</p>
                    <p className={classes.normalParagrah}>
                      Acción que por una vez permite al prestador solicitar una prórroga de plazo automática, ante una
                      solicitud de información por parte de la Superintendencia de Salud.
                    </p>
                  </div>
                </li>
                <li>
                  <div className={classes.listInLine}>
                    <p className={classes.underlinedText}>Detalle:</p>
                    <p className={classes.normalParagrah}>
                      Acción que permite visualizar el detalle del reclamo, con sus datos principales, y sus documentos
                      relacionados.
                    </p>
                  </div>
                </li>
              </ol>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </Fragment>
  );
};

export default AyudaBodyInfo;
